module.exports = __webpack_public_path__ + "img/service3_active.415f1dea.png";